import React, { useState } from 'react';
import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Select,
  Text,
  Button,
  Collapse,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaFilter } from 'react-icons/fa';

const FilterBar = ({ onFilterChange }) => {
  const textColor = useColorModeValue('secondaryGray.500', 'white');
  const [isOpen, setIsOpen] = useState(false);
  const [filters, setFilters] = useState({
    status: '',
    clinic_role: '',
    location: '',
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    const updatedFilters = { ...filters, [name]: value };
    setFilters(updatedFilters);
    onFilterChange(updatedFilters);
  };

  console.log('Selected filters', filters);

  return (
    <Box borderBottom="1px solid #EFEFF1" pb={4} mb={4}>
      <Flex align="center" justify="space-between">
        <Flex
          display={{ base: 'flex', md: 'none' }}
          cursor="pointer"
          align="center"
          onClick={() => setIsOpen(!isOpen)}
          sx={{border:"1px solid #8f9bba",borderRadius:"8px",pl:3}}
        >
          <Text
            color={textColor}
            fontSize="md"
            fontWeight="700"
            lineHeight="100%"
          >
            Filters{' '}
          </Text>
          <Button
            padding="0px !important"
            backgroundColor="transparent !important"
          >
            <FaFilter className="filterIcon" size="12px" />
          </Button>
        </Flex>

        <Flex display={{ base: 'none', md: 'flex' }} align="center" gap={2}>
          <Text
            color={textColor}
            fontSize="md"
            fontWeight="700"
            lineHeight="100%"
            mb={{ base: '8px', md: '0px' }}
          >
            Filters{' '}
          </Text>
          <FaFilter className="filterIcon" size="12px" />
        </Flex>

        <Flex
          display={{ base: 'none', md: 'flex' }}
          gap={4}
          ml="auto"
          flexWrap="wrap"
        >
          <FormControl w="150px">
            <Select
              name="status"
              placeholder="All Status"
              size="sm"
              borderRadius="12px"
              value={filters.status}
              onChange={handleFilterChange}
            >
              <option value="accepted">Accepted</option>
              <option value="pending">Pending</option>
            </Select>
          </FormControl>
          <FormControl w="150px">
            <Select
              name="clinic_role"
              placeholder="All Roles"
              size="sm"
              borderRadius="12px"
              value={filters.clinic_role}
              onChange={handleFilterChange}
            >
              <option value="staff">Staff</option>
              <option value="lab">Lab</option>
              <option value="admin">Admin</option>
            </Select>
          </FormControl>
        </Flex>
      </Flex>

      <Collapse in={isOpen} animateOpacity>
        <Flex
          direction="column"
          gap={4}
          mt={4}
          display={{ base: 'block', md: 'none' }}
          border="1px solid #e2e8f0"
          borderRadius="16px"
          p={4}
        >
          <FormControl mb={2}>
            <FormLabel>Status</FormLabel>
            <Select
              name="status"
              placeholder="Select Status"
              size="sm"
              borderRadius="12px"
              value={filters.status}
              onChange={handleFilterChange}
            >
              <option value="accepted">Accepted</option>
              <option value="pending">Pending</option>
            </Select>
          </FormControl>
          <FormControl mb={2}>
            <FormLabel>Role</FormLabel>
            <Select
              name="role"
              placeholder="Select Role"
              size="sm"
              borderRadius="12px"
              value={filters.role}
              onChange={handleFilterChange}
            >
              <option value="staff">Staff</option>
              <option value="lab">Lab</option>
              <option value="admin">Admin</option>
            </Select>
          </FormControl>
        </Flex>
      </Collapse>
    </Box>
  );
};

export default FilterBar;
